import { render, staticRenderFns } from "./RegisterInput.vue?vue&type=template&id=c3a31264&scoped=true&"
import script from "./RegisterInput.vue?vue&type=script&lang=js&"
export * from "./RegisterInput.vue?vue&type=script&lang=js&"
import style0 from "./RegisterInput.vue?vue&type=style&index=0&id=c3a31264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a31264",
  null
  
)

export default component.exports